import React, { useEffect } from 'react'
import './Drawer.css'

const DrawerUI = ({
  isOpen,
  title,
  onClose,
  children,
  className,
  width = '720px',
}) => {
  useEffect(() => {
    if (!isOpen) return undefined
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose()
    }
    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', onKeyDown)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div className={`w_drawer ${className || ''}`}>
      <div className='w_drawer_backdrop' onClick={onClose} />
      <aside
        className='w_drawer_panel'
        style={{ maxWidth: width }}
        role='dialog'
        aria-modal='true'
        aria-label={typeof title === 'string' ? title : 'Drawer'}
      >
        <header className='w_drawer_header g_flex_h'>
          <span className='w_drawer_title'>{title}</span>
          <span className='icon icon-times w_drawer_close' onClick={onClose} />
        </header>
        <div className='w_drawer_body'>
          {children}
        </div>
      </aside>
    </div>
  )
}

export default DrawerUI
